import React from "react";
import SalesHistory from "../components/salesHistory/salesHistory";
import { useParams } from 'react-router-dom';

export default function SalesHistoryRouter() {
  const { id } = useParams();
  return <SalesHistory id = {id} />;
}
